import { Link } from 'react-router-dom'

// The bottom of the sidebar: who you are, and the two things you can do about it. Changing your
// password is not a feature the tenant unlocks and not an admin surface — everybody has an account,
// so everybody has this — which is why it sits here beside Sign out rather than on Settings.

export interface SidebarFootProps {
  displayName: string | null | undefined
  /** where to come back to after a successful change */
  from: string
  onSignOut: () => void
}

export function SidebarFoot({ displayName, from, onSignOut }: SidebarFootProps) {
  return (
    <div className="sidebar-foot">
      <span className="muted">{displayName}</span>
      <Link className="link" to="/account/password" state={{ from }}>
        Change password
      </Link>
      <button className="link" onClick={onSignOut}>
        Sign out
      </button>
    </div>
  )
}
